import React from "react";

const Status = ({ modalData, updateModalState }) => {
  const getStatus = (status) => {
    updateModalState("isActive", status);
  };
  return (
    <ul className="modal-status">
      <li
        className={`${modalData.isActive ? "active" : ""}`}
        onClick={() => getStatus(true)}
      >
        Aktiv
      </li>
      <li
        className={`${modalData.isActive ? "" : "active"}`}
        onClick={() => getStatus(false)}
      >
        Deaktiv
      </li>
    </ul>
  );
};

export default Status;
